import axios from "axios";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT } from "../../constants/constants";

async function getProviderList() {
    const requestOptions = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getAccessToken()}`,
            "Access-Control-Allow-Origin": API_ROOT,
        },
    };

    const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/forwarder/getProviderList`, requestOptions
    );
    const providerList = response.data;
    return providerList;
}
export default getProviderList;